import { createContext, useState, useEffect, ReactNode } from 'react'
import auth from '../utilities/firebase-auth'
import { LoginContextType } from '../types/andTypes'
import {
  onAuthStateChanged,
  User,
  getAuth,
  OAuthCredential,
  signInWithCredential
} from 'firebase/auth'

export const LoginContext = createContext({} as LoginContextType)

export interface LoginProviderProps {
  children: ReactNode
}

export const LoginProvider = ({ children }: LoginProviderProps) => {
  const fAuth = getAuth()
  const fUser = fAuth.currentUser

  const [user, setUser] = useState<User | null>(fUser)
  const [isLoading, setIsLoading] = useState(!fUser)

  const DOMAIN = '@and.digital'

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      const authUser = user?.email?.includes(DOMAIN) ? user : null
      setUser(authUser)
      setIsLoading(false)
    })
    return unsubscribe
  }, [])
  const handleAuth = async (credential?: OAuthCredential) => {
    if (user) {
      await auth.signOut()
      setUser(null)
    } else if (credential) {
      const result = await signInWithCredential(auth, credential)
      if (result.user?.email?.includes(DOMAIN)) {
        setUser(result.user)
      } else {
        throw new Error('DOMAIN')
      }
    }
  }

  return (
    <LoginContext.Provider
      value={{
        user,
        authenticated: user !== null,
        setUser,
        handleAuth,
        isLoading
      }}
    >
      {children}
    </LoginContext.Provider>
  )
}
